module.exports = __webpack_public_path__ + "img/pic-3.3f40f679.png";